module.exports = __webpack_public_path__ + "img/北京.e24711b8.png";